import { Spinner } from "@visiblethread/react-components";
import Flex from "components/Flex";
import {
  isSiteBlocked,
  SITE_ACCESS_MESSAGES,
  SITE_ACCESS_STATUS,
} from "constants/sharepointAccess";
import { arrayOf, bool, shape, string } from "prop-types";

import CheckboxAction from "./Actions/CheckboxAction";
import PinAction from "./Actions/PinAction";
import RetryAccessAction from "./Actions/RetryAccessAction";
import styles from "./ActionsCell.module.scss";

const ActionsCell = ({ row, selectedFiles, appliedFiles, isSite }) => {
  const item = row.original;

  if (isSite && isSiteBlocked(item)) {
    if (item.accessStatus === SITE_ACCESS_STATUS.CHECKING) {
      return (
        <Flex
          as="span"
          justifyContent="center"
          className={styles.actionsCell}
          role="img"
          aria-label={`${SITE_ACCESS_MESSAGES[SITE_ACCESS_STATUS.CHECKING].title} for ${item.name}`}
        >
          <Spinner size={14} />
        </Flex>
      );
    }
    return item.accessStatus === SITE_ACCESS_STATUS.UNKNOWN ? (
      <Flex as="span" justifyContent="center" className={styles.actionsCell}>
        <RetryAccessAction item={item} />
      </Flex>
    ) : null;
  }

  if (item.type === "file" || item.type === "SP.File" || isSite) {
    const isChecked = selectedFiles.some(
      (selectedFile) => selectedFile.name === item.name
    );

    const isApplied = appliedFiles.some((appliedFile) => {
      if (appliedFile.source === "Sharepoint") {
        return (
          appliedFile.content.hash === item.hash &&
          appliedFile.content.name === item.name
        );
      }
      return (
        appliedFile.hash === item.hash && appliedFile.content.name === item.name
      );
    });

    return (
      <span className="file_explorer__list__item__actions">
        {isSite ? (
          <PinAction item={item} />
        ) : (
          <CheckboxAction
            item={item}
            isApplied={isApplied}
            isChecked={isChecked}
          />
        )}
      </span>
    );
  }
  return null;
};

ActionsCell.propTypes = {
  row: shape({
    original: shape({
      type: string.isRequired,
      name: string.isRequired,
      hash: string,
      id: string,
      isPinned: bool,
      accessStatus: string,
    }).isRequired,
  }).isRequired,
  selectedFiles: arrayOf(
    shape({
      name: string.isRequired,
    })
  ).isRequired,
  appliedFiles: arrayOf(
    shape({
      content: shape({
        name: string.isRequired,
        hash: string,
      }),
      source: string,
      hash: string,
    })
  ).isRequired,
  isSite: bool.isRequired,
};

export default ActionsCell;
